import { render, staticRenderFns } from "./RecuperarSenha.vue?vue&type=template&id=140055d8&scoped=true&"
import script from "./RecuperarSenha.vue?vue&type=script&lang=js&"
export * from "./RecuperarSenha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140055d8",
  null
  
)

export default component.exports